var fontlist = ['Rigid','Industry','Black Ops','Freckle Face','Geo','Germania','Tektur','Jaro','Edo','Asimovian']

var font_align = [45,42,42.64,45,50,42,42.64,57.69,46.51,50.1]
var font_sizes = [100,100]

var pattern_url = "//cdn.shopify.com/s/files/1/0416/3169/t/28/assets/";
var thumb_url = "//cdn.shopify.com/s/files/1/0416/3169/t/28/assets/";

var singlets = ['YEREVAN','VAPR','HALO','FARGO','CORTEX','CHASE','KABEL','COPA','EVOLUTION','PLANO','JAKARTA','TIQUE',
                'PERCEPTOR','VADER','AVALANCHE','DARKVENOM','LUDWIG','INSIDER',
                'ZENTRUM','GLACIAL','PHENOM','TRAQUE','COSMOS','FORZA','VIPER','EVO',
                'VENOM','BURNHAM','SHIRES','MEISTER','HARDT','DWINELLE','GANBARU','AVEDA','ROOTS',
                'GLAMORGAN','DYNAMO','TRANSFORMER','POINTAGE'];

 // 'KABEL','COPA','EVOLUTION','PLANO','DEBACLE','JAKARTA',
 
var scolors = ['white#FFFFFF','black#000000','titanium#53575a','cool grey#898a8d',
               'navy#0a2240','royal#0033a1','mars red#ce0e2d','electric blue#0099dc','electric green#74af0d','cardinal#8a2432']

var phpurl = "";
var picker
var space = 7;
				
var curthumbpage = 0
var maxthumbpage = 0

var curpattpage = 0
var maxpattpage = 0

var currdesign 
var currcoltab = 0;
var initcolors = ['000000','8dc6e8','e5e1e6',"000000","ffffff","ffffff","ffffff"];
var currcolors	
var logholders = [['TURN_LOGO_-_FRONT_LEFT','TURN_LOGO_-_FRONT_RIGHT','TURN_LOGO_-_FRONT_CENTER','TURN_LOGO_-_BACK_YOKE'],
					'TEAM_LOGO','TEAM_NAME_-_FRONT','TEAM_NAME_-_BACK']
					
var currlogos=[2,1,0,0]
var teamname 
var swatches = [0,0,0,0,0,0,0,0,0,0]

var patterns = ['jungla','tisse','wavy','ecke','furore','graft','depot','pacific','trinity','halle','swift','armour','constructo','lightning','prism','hyper','shards','swish']
var currpattern = -1
var currpatype = 0
var currside = [0,0]

var font_id = 0
var team_name = "TEAM NAME"
var curr_bind = 1;
let fs_on = false;

function isOverflowed(element){
    return $(element).children('div').innerWidth() >  $(element).innerWidth();
}


function onPageResize(){
  
	let ww  = $('#uniform-wrapper').parent().innerWidth()
  
	if(ww<=1024 && fs_on==false){
		sc = ww/1024
	}else{
		sc = 1
	}
	resizeBuilder(sc);
}

function resizeBuilder(sc){

  if(fs_on==false) {
    $('#uniform-wrapper').css({
		'transform-origin':'50% 0%',
		'-webkit-transform-origin':'50% 0%',
		'-moz-transform-origin':'50% 0%',
		'-o-transform-origin':'50% 0%',
		'-ms-transform-origin':'50% 0%',
		'transform':'scale('+sc+')',	
		'-webkit-transform':'scale('+sc+')',	
		'-moz-transform':'scale('+sc+')',	
		'-o-transform':'scale('+sc+')',	
		'-ms-transform':'scale('+sc+')',
        'top': '0px'
    });
	
    $('#uniform-wrapper').parent().css({'overflow':'hidden','height':720*sc});

    
  } else {
    
        $('#uniform-wrapper').css({
            'transform':'scale('+sc+')',
            '-webkit-transform':'scale('+sc+')',
            '-moz-transform':'scale('+sc+')',
            '-o-transform':'scale('+sc+')',
            '-ms-transform':'scale('+sc+')',
            'top': 'calc(50% - 380px)'
 
        });

      $('#uniform-wrapper').parent().css({'overflow':'hidden','height':'100%', 'background':'white'});
      
    }

     $('#footer-wrapper').css({'margin-bottom':'-52px'});
    //$('#page').css({'margin-bottom':'-30px'})
}
				
function initSinglets(){

  
    $(window).bind('resize',onPageResize)
    setTimeout(onPageResize, 500);


    // check fullscreen mode
    
    if(screenfull.isEnabled==true) {
  
        screenfull.on('change', function() {
  
            fs_on = screenfull.isFullscreen ?true:false;
            if(fs_on==false) {
                $('.wu-fs-btn').removeClass('on');
            }
  
  
        });
  
    } else {
  
        // if device doesnt support fullscreen mode
    }

   $('.wu-fs-btn').click(function() {

     if(!$(this).hasClass('on')){
          
         screenfull.request($('#uniform-wrapper').parent()[0]);
         $('.wu-fs-btn').addClass('on');

      } else {
         screenfull.exit();
         setTimeout(onPageResize, 500);
      }

  });
  
   //$('.price-curr').bind('click',onCurrencyChange)
	
	$('#req-date').Zebra_DatePicker({direction:true, format:"m.d.Y",onSelect:onDateSelect,onClear:onDateClear});
	comboBox(fontlist,$('#font-select'))	

    $('#team-input').on('input',onTeamInput);
	//$('#team-input, #q-team').bind('keyup',onTeamInput)
	
	$('#q-qty').bind('keyup',calculatePrice)
	
	
	/****************************************/
	
	
	$('#q-file').change(function (){
		var fsplit = $('#q-file').val().split("\\")
		var fname = fsplit[fsplit.length -1].length>0?"":"TEAM LOGO UPLOAD";
		$('#atbtn').text(fname.toString());
      	$('#atbtn').addClass('file-checked');
	})
    
	addPatThumbs()
	initQuoteForm()
	picker = $.farbtastic('#picker');
	picker.linkTo(setColorByPicker)
	$('#color').on('input',onColorInput)
	$('#swatch-btn').bind('click',addToSwatches)
	$('.logthumb').bind('click',onLogThumbClick)
    $('.namelogchoose').bind('click',onNameChooseClick)
	$('.teamlogchoose').bind('click',onLogChooseClick)
	$('.share-new-btn:not(:has(input))').bind('click',shareDesign)
	$('.tooltipster-icon').tooltipster({touchDevices:true,animation:'grow',speed:150,iconTouch:true,distance:3});
	
	$('.patternchoose').bind('click',function(){
		setPatternType($(this).index())
	})
	
	$('.sidechoose').bind('click',function(){
		setPatternSide($(this).index())
	})
	
	$('#team-text').focusin(function(){
		if($('#team-text').val()=='*Separate your teammates emails with a comma'){
			$('#team-text').val('')	
		}	
	})
	$('#team-text').focusout(function(){
		if($('#team-text').val()==''){
			$('#team-text').val('*Separate your teammates emails with a comma')	
		}	
	})
	
	$('#q-text').focusin(function(){
		if($('#q-text').val()=='COMMENTS'){
			$('#q-text').val('')	
		}	
	})
	
	$('#q-text').focusout(function(){
		if($('#q-text').val()==''){
			$('#q-text').val('COMMENTS')	
		}	
	})
    
    $('.b-select').click(function() {
    	setBinding($(this).index()-1)
    })
	
	var swatch_coockies = getCookies('swatches')==undefined?swatches:getCookies('swatches').split('-')
	swatches = swatch_coockies;
	removeLogos()
	
	var query = window.location.href.indexOf('#')!=-1?window.location.href.split('#')[1]:window.location.href.split('=')[1]
	
	if(query==undefined || query==''){
		currdesign = 0
		currcolors = initcolors 
		currlogos = [2,1,0,0]
		teamname = ""
		currpattern = -1
		currpatype = 0
		currside = [1,1]
		font_id = 0
		team_name = "TEAM NAME";
        curr_bind = 1;
		//font_sizes = [50,70]
	}else{
		dparts = query.split('/')
		currdesign = dparts[0]
		currcolors = dparts[1].split('-')
		currlogos = dparts[2].split('-')
		teamname = dparts[3]
		currpattern = dparts[4]
		currpatype = dparts[5]
		currside = dparts[6].split('-')
		font_id = dparts[7]?dparts[7]:6
		team_name = dparts[8]?decodeURIComponent(dparts[8]):"TEAM NAME"
        curr_bind = dparts[10]?dparts[10]:0;
		//font_sizes = dparts[9].split('-')
	}
	
  $("#clip-wrapper").svg({loadURL: "//www.turn-gymnastics.com/cdn/shop/t/28/assets/singlets-clip.svg?v=99818123805481577371777368319",onLoad:function(){
    $("#design").svg({loadURL: "//www.turn-gymnastics.com/cdn/shop/t/28/assets/singlets.svg?v=48737133722364451071775716993",onLoad:function(){

		
		initNewGradientStyle();

         addThumbs()
         setColor($('.col2'),'#'+currcolors[1])
         setColor($('.col3'),'#'+currcolors[2])
         setColor($('.col4'),'#'+currcolors[3])
         setColor($('.col5'),'#'+currcolors[4])
         setColor($('.col6'),'#'+currcolors[5])

         /*** set first tab sample color again ***/
         setColor($('.col1'),'#'+currcolors[0])

         setLogos()
         addStockColors()
         addSwatches()
         setLogosOnLoad()
         setBinding(curr_bind)

         setTeamName(team_name)
         setTeamFont(font_id)
         $('.b-select').eq(curr_bind).click();

         $('.pattern-fill').attr('fill','url(#pat-loaded)');
        // if(currpattern != -1){
          setPatternType(currpatype)
          $(currside).each(function(index, element) {
              if(element==1){
                  setPatternSide((index+2))
              }
          });
        // }

        initGradientPicker();
      }
     });
	}
   });
	
	
	gotoTab(0)
	setColTab(0)
	$('#menu div').bind('click',tabClick)
	$('#colours li').bind('click',colTabClick)
	$('.th-nav-btn').bind('click',thNavClick)
	
	/**** show after loading complete ********/
	/*var i=0;
	var l=$('#uniform-wrapper img').length
	$('#uniform-wrapper img').load(function(){
		
		i++
		if(i==l){
			$('#hider').animate({opacity:0},700,function(){$('#hider').css('display','none')})
		} 
	})
    */
    $('#hider').animate({opacity:0},700,function(){$('#hider').css('display','none')})
    
    createManipulationUI();
}

/****************************************/
/******** add pattern thumbs ************/
/****************************************/
function addPatThumbs(){
	$(patterns).each(function(index,element){
				
		var pt = '<div class="pat-thumb"><img src="'+pattern_url+element+'.jpg" /><div class="pat-thumb-title">'+element.toUpperCase()+'</div></div>'
		$(pt).appendTo('#pat-holder')
        var tx = (Math.floor(index/3))*(103+space)
		var ty = index*(162-space*3) - Math.floor(index/3)*(162-space*3)*3;
		
		$('#pat-holder .pat-thumb:eq('+index+')').css({'left':tx,'top':ty})
        
        var thnew = '<img style="height:32px; width:45px; margin-top:30px; left:20px;" src="//www.turn-gymnastics.com/cdn/shop/t/28/assets/new.png?v=155953233748053933311745397165" />'
        
		// add new badge to some of the thumbs
        if (index==0 || index==1 || index==2){
			$(thnew).appendTo($('#pat-holder .pat-thumb:eq('+index+')'))
		}

	})
	
	$('.pat-thumb').bind('click',onPatternSelect)
}

function onPatternSelect(){
	setPattern($(this).index())
}

/****************************************/
/********* menu functions **************/
/****************************************/

function tabClick(){
	var id = $(this).index();
	gotoTab(id);
}

function gotoTab(id){
	var ctab = $('#menu div:eq('+id+')');
	$('#menu div').removeClass('active');
	$(ctab).addClass('active');
	$('#slide-content').stop();
	$('#slide-content').animate({left:-id*322},700)

	if(id==3) {
		$('#sw-st-cont').insertAfter('#n-yes').addClass('grad-scwatch');
		currcoltab = 5;
	} else {
		$('#sw-st-cont').insertAfter('#gradient-picker').removeClass('grad-scwatch');
		$('#colours .menu-selected').trigger('click');

	}
}



/****************************************/
/********* thumb functions **************/
/****************************************/

function addThumbs(){

	let patVisible = 6;
	let rows = 2;
	
	//thumb pages
	
	var pagecount = Math.floor(singlets.length/patVisible)
	maxthumbpage = pagecount==singlets.length/patVisible?pagecount-1:pagecount
	
	if (pagecount>0){
		$('#page-count').show()
	}else{
		$('#page-count').hide()
	}
	
	$('#page-count').text((curthumbpage+1)+'/'+(maxthumbpage+1))
	
	if(singlets.length>patVisible){
		$('#th-right').show()
	}
	
	// pattern pages
	
	var pattpagecount = Math.floor(patterns.length/9)
    maxpattpage = pattpagecount==patterns.length/patVisible?pattpagecount-1:pattpagecount
	
	if (pattpagecount>0){
		$('#pat-page-count').show()
	}else{
		$('#pat-page-count').hide()
	}
	
	$('#pat-page-count').text((curpattpage+1)+'/'+(maxpattpage+1))
	
	if(patterns.length>patVisible){
		$('#pat-right').show()
	}
	
	
	$(singlets).each(function(index, element) {
		var thname = singlets[index].toLowerCase()+'.png?' + new Date().getTime();
        var thsample = '<div class="thumb"><img src="'+thumb_url+thname+'" /><div class="thumb-title">'+singlets[index]+'</div></div>'
		$(thsample).appendTo($('#thumbs-holder'))

		var tx = Math.floor(index / rows) * (103 + space);
		var ty = (index % rows) * (152 - space);

		$('#thumbs-holder .thumb:eq('+index+')').css({'left':tx,'top':ty})
		$('#thumbs-holder .thumb:eq('+index+')').bind('click',thumbClick)
		
        var thnew = '<img style="height:32px; width:45px; margin-top:45px; left:25px;" src="//www.turn-gymnastics.com/cdn/shop/t/28/assets/new.png?v=155953233748053933311745397165" />'
        
		// add nwe badge to some of the thumbs
		if (index==0 || index==1 || index==2 || index==3 || index==4 || index==5){
        	$(thnew).appendTo($('#thumbs-holder .thumb:eq('+index+')'))
        }
    });
	
	loadDesign(currdesign)
	if(currdesign>8){
		navigateToPage('th-right')
	}
}

function thumbClick(){
	var id = $(this).index()
	loadDesign(id)
}

function loadDesign(id){
	$('#design-title').text(singlets[id])
	//$('.unisample').css('opacity',0)
	$('.unisample').css('display','none')
	var cdesign = $(document).find('.unisample[id='+singlets[id]+']')
	//$(cdesign).css('opacity',1)	
	$(cdesign).css('display','inline')
	$('#thumbs-holder .thumb-title').removeClass('thumb-title-selected')
	$('#thumbs-holder .thumb-title:eq('+id+')').addClass('thumb-title-selected')
	currdesign = id;
  
    if(singlets[currdesign].toLowerCase() == "ganbaru") {

     $('#col2-gradient stop:eq(0)').attr('stop-color','#'+currcolors[1])
     $('#col2-gradient stop:eq(1)').attr('stop-color','#'+currcolors[2])

     $('.col-grad').attr('fill','url(#col2-gradient)')
     $('.col-grad').find('path,rect,polygon,polyline').not('[class*="pattern-fill"]').attr('fill','url(#col2-gradient)')

    }
	
	$('#svg-file').val(encodeURIComponent($('#design').html()))
}

function thNavClick(){
	navigateToPage($(this).attr('id'))
}

function navigateToPage(dir){
	if(dir=='th-right'||dir=='th-left'){
		if(dir=='th-right'){
			$('#th-left').show()
			curthumbpage++
			if(curthumbpage>maxthumbpage-1){
				$('#th-right').hide()
			}
		}else{
			$('#th-right').show()
			curthumbpage--
			if(curthumbpage==0){
				$('#th-left').hide()
			}
		}
		$('#thumbs-holder').animate({left:-curthumbpage*(322+space)},{duration:400,
		
		 /********* remove flickering ***********/
			step:function(){
				$('#thumbs').hide();
				$('#thumbs').show(.0001)
			}
		})
		
		$('#page-count').text((curthumbpage+1)+'/'+(maxthumbpage+1))
	}
	
	if(dir=='pat-right'||dir=='pat-left'){
		if(dir=='pat-right'){
			$('#pat-left').show()
			curpattpage++
			if(curpattpage>maxpattpage-1){
				$('#pat-right').hide()
			}
		}else{
			$('#pat-right').show()
			curpattpage--
			if(curpattpage==0){
				$('#pat-left').hide()
			}
		}
		$('#pat-holder').animate({left:-curpattpage*(322+space)},{duration:400,
		
		 /********* remove flickering ***********/
			step:function(){
				$('#patterns').hide();
				$('#patterns').show(.0001)
			}
		})
		
		$('#pat-page-count').text((curpattpage+1)+'/'+(maxpattpage+1))
	}
	
}


/****************************************/
/********* color functions **************/
/****************************************/

function addStockColors(){
	var rows = 14
	var space = 1
	$(scolors).each(function(index, element) {
		var cname = element.split('#')[0].toUpperCase()
		var cval = '#'+element.split('#')[1]
        var csample = '<div class="swatch tooltip" title="'+cname+'" style="background-color:'+cval+'"></div>'
		$(csample).appendTo($('#stock'))
		var tx = index*(22+space) - Math.floor(index/rows)*(22+space)*rows;
		var ty = 30+ (Math.floor(index/rows))*(22+space)
		$('#stock .swatch:eq('+index+')').css({'left':tx,'top':ty,'background-color':cval})
		$('#stock .swatch:eq('+index+')').bind('click',swatchClick)
    });
}

function addSwatches(){
	$(swatches).each(function(index, element) {
		var cval = element==0?'#fff':'#'+element
		var cname = element==0?'empty':cval;
		var xval = element==0?'x':''
	    var csample = '<div class="swatch tooltip" title="'+cname+'">'+xval+'</div>'
		$(csample).appendTo($('#swatch'))
		$('#swatch .swatch:eq('+index+')').css({'background-color':cval})
		$('#swatch .swatch:eq('+index+')').bind('click',swatchClick)
	});
	$('.tooltip').tooltipster({touchDevices:false,animation:'grow',speed:150});
}



function colTabClick(){
	var id = $(this).index();
	if (id==5) id=6;
	currcoltab = id;
	setColTab(id);
}

function setColTab(id){

	if(id!=6){
		isgradient = false
		$('#gradient-picker').hide()
		$('.grad-color').removeClass('grad-focus');
		$('#col-picker').removeClass('gradpick');
	}else{

		$('#gradient-picker').show();
		$('#col-picker').addClass('gradpick');
		if($('#grad-check').hasClass('grad-check-selected')){
			isgradient = true;
		}
	}
  
	id = id==6?5:id; // rename id for gradient
	var ctab = $('#colours li:eq('+id+')');
	$('#colours ul li').removeClass('menu-selected');
	$(ctab).addClass('menu-selected');

	var colselected = isgradient == false?currcolors[currcoltab]:grad_color[0].split('#')[1]
	console.log(colselected);
	picker.setColor('#'+colselected);
}


function swatchClick(){
	
	var swcolor = $(this).css('background-color')
	
	/**** if swatch is not change color *****/
	
	if($(this).tooltipster('content')!='empty'){
		if(isgradient==false){
			picker.setColor(RGBtoHEX(swcolor));
			setColor($('.col'+(currcoltab+1)),swcolor)
		}else{
			$('#colsamp').css('background-color',swcolor)
			picker.setColor(RGBtoHEX(swcolor));
		}
	}

}

function setColorByPicker(){
	var pcolor = picker.color;
	$('#color').val(pcolor);

	if (currcoltab !=6) {
		currcolors[currcoltab]  = pcolor.split('#')[1];
		setColor($('.col'+(currcoltab+1)),pcolor);
	}else{
		grad_color[0] = pcolor;
		onGradPicker();
	}
}


function setColor(part,value){

  
    //for gradients
    let pc = $(part).attr('class')
    $('.'+pc+'grad').attr('fill',value);

	$(part).css('color',value)
	$(part).attr('fill',value)
	$(part).find('path,rect,polygon,polyline').not('[fill*="url"]').attr('fill',value)
	$(part).find('stop').css('stop-color',value)

  
	$('#colsamp').css('background-color',value)
    
    if(singlets[currdesign].toLowerCase() == "ganbaru") {

     $('#col2-gradient stop:eq(0)').attr('stop-color','#'+currcolors[1])
     $('#col2-gradient stop:eq(1)').attr('stop-color','#'+currcolors[2])

     $('.col-grad').attr('fill','url(#col2-gradient)')
     $('.col-grad').find('path,rect,polygon,polyline').not('[class*="pattern-fill"]').attr('fill','url(#col2-gradient)')

    }
    
   $('#svg-file').val(encodeURIComponent($('#design').html()))
}

function RGBtoHEX (color) {
  return "#"+$.map(color.match(/\b(\d+)\b/g),function(digit){
    return ('0' + parseInt(digit).toString(16)).slice(-2)
  }).join('');
};

function onColorInput(){
	var ival = $(this).val().split('#')
	var tval = ival.join('')
	$(this).val('#'+tval)
	picker.setColor($(this).val());
}

function addToSwatches(){
	var scolor = picker.color
	$('#swatch .tooltip').tooltipster('destroy');
	
	var duplicate=false
	$(swatches).each(function(sindex, selement) {
		if(scolor.split('#')[1] == selement){
			duplicate=true
			return false;
		}
	})
	if(duplicate==false){
	$(swatches).each(function(index, element) {
		if(element==0){
			swatches[index] = scolor.split('#')[1]
			$('#swatch .swatch:eq('+index+')').css({'background-color':scolor})
			$('#swatch .swatch:eq('+index+')').text('')
			$('#swatch .swatch:eq('+index+')').attr('title',scolor)
			setCookies()
			return false;
		}
		if(index==13 && element!=0){
			swatches.splice(0,1)
			swatches.push(scolor.split('#')[1])
			replaceSwatches()
		}
	});
	}
	
	$('#swatch .tooltip').tooltipster({touchDevices:false,animation:'grow',speed:150});
}



function replaceSwatches(){
	$(swatches).each(function(index, element) {
		$('#swatch .swatch:eq('+index+')').css('background-color','#'+swatches[index])
		$('#swatch .swatch:eq('+index+')').attr('title','#'+swatches[index])
    });
	$('#swatch .tooltip').tooltipster({touchDevices:false,animation:'grow',speed:150,distance:3});
	setCookies()
}

function setCookies(){
	document.cookie='swatches='+swatches.join('-');
}

function getCookies(name){
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}


/****************************************/
/*************** logo functions *********/
/****************************************/
function onLogThumbClick(){
	var par = $(this).parent().parent().attr('id')
	var id = $(this).index()
	setLogoStats(par,id,$(this))
	$('#svg-file').val(encodeURIComponent($('#design').html()))
}

function onLogChooseClick(){
	var id = $(this).index()
	setLogChooseStat($(this).attr('id'))
}

function setLogChooseStat(id){
	var tgt = $('#'+id)
	$('.teamlogchoose').removeClass('logo-selected')
	$(tgt).addClass('logo-selected')
	if(id=='no'){
		currlogos[1]=0
	}else{
		currlogos[1]=1
		//currlogos[2]=0
		//$('#team-center').removeClass('logo-thumb-selected')
	}
	setLogos()
}

function onNameChooseClick() {
	var id = $(this).index()
	setNameChooseStat($(this).attr('id'))
}

function setNameChooseStat(id){
	var tgt = $('#'+id)
	$('.namelogchoose').removeClass('logo-selected')
	$(tgt).addClass('logo-selected')
	if(id=='n-no'){
		currlogos[2]=0
	}else{
		currlogos[2]=1
	}
	setLogos()
}

function setLogoStats(parent,thid){
  
	
	var par = parent
	var id = thid
	var target = $('#'+par).find('.logthumb:eq('+id+')')
	
	if(par=="turn-logo"){

			//if($(target).hasClass('logo-thumb-selected')){
			 // $(target).removeClass('logo-thumb-selected')
			 // currlogos[0]=-1
			  
			//}else{
			  $('#turn-logo .logthumb').removeClass('logo-thumb-selected')
			  $(target).addClass('logo-thumb-selected')
			  currlogos[0]=id
			//}		
	}

	
	if(par=="team-name"){
      
    	$('#team-name .logthumb').removeClass('logo-thumb-selected')
		$(target).addClass('logo-thumb-selected')
		currlogos[2]=id
      
// 		if(id==0){
// 			setLogChooseStat('no')
// 			//currlogos[3]=1
// 			//$('#team-logo .logthumb:not(.toggle').removeClass('logo-thumb-selected')
// 			//$(this).addClass('logo-thumb-selected')
// 			if(currlogos[2]==0){
// 				currlogos[2]=1
// 				$(target).addClass('logo-thumb-selected')
// 			}else{
// 				currlogos[2]=0
// 				$(target).removeClass('logo-thumb-selected')
// 			}
// 		}else{
// 			if(currlogos[3]==0){
// 				currlogos[3]=1
// 				$(target).addClass('logo-thumb-selected')
// 			}else{
// 				currlogos[3]=0
// 				$(target).removeClass('logo-thumb-selected')
// 			}
// 		}
	}
	setLogos()
}

function removeLogos(){
	$(logholders).each(function(index, element) {
		if(index==0){
			$(element).each(function(tindex, telement) {
               $('.'+telement).css('opacity',0)
            });
		}else{
            var tgt = element.indexOf('TEAM_NAME')==-1?$('.'+element):$('#'+element)
        	$(tgt).css('opacity',0)
		}
    });
}

function setLogosOnLoad(){
	$('#turn-logo .logthumb:eq('+currlogos[0]+')').addClass('logo-thumb-selected')
	
	if(currlogos[1]==1){
		$('#yes').addClass('logo-selected')
	}
	
	if(currlogos[2]==1){
		//$('#team-center').addClass('logo-thumb-selected')
      	$('#n-yes').click()
    } else {
    	$('#n-no').click()
    }
	
	if(currlogos[3]==1){
		$('#team-back').addClass('logo-thumb-selected')
	}
	$('#svg-file').val(encodeURIComponent($('#design').html()))

}


function setLogos(){
	
	removeLogos()
	
	$(currlogos).each(function(index, element) {
        if(index==0 && element!=-1){
			setLogo(logholders[index][element],1)
		}else{
			setLogo(logholders[index],element)
		}
    });
	
	$('#svg-file').val(encodeURIComponent($('#design').html()))
}


function setLogo(target,value){
	var tgt = target.indexOf('TEAM_NAME')==-1?$('.'+target):$('#'+target)
	//$(tgt).show()
	
	if(value==1){
		$(tgt).css('opacity',1)
	}else{
		$(tgt).css('opacity',0)
	}
	//$('#svg-file').val(encodeURIComponent($('#design').html()))
}


/********************************************/
/************ share functions ***************/
/********************************************/

let succ_int = null;

function shareDesign(){
  
	const platform = $(this).attr('id');
	const tgtbtn = $(this);
	let share_url = getDesignUrl();
	let body_content = "Check out our brand new uniform:<br><br>"+share_url;
	let team_mails = [];
	let team_count = 0;

	// footer is added directly in AAA form builder

	$('#share-form #share-msg').html(body_content);

	if(platform=='sembtn') {
		$('#share-form #replyemail').val($('#self-mail').val());
	} else {
		team_mails = $('#team-text').val().replaceAll(/\s/g,'').split(',');
		$('#share-form #replyemail').val(team_mails[team_count]);
	}


	// disable form temporary
	$('#overview').css({
		'opacity':0.7,
		'pointer-events': 'none'
	})
	
	$(tgtbtn).find('.share-new-btn-text').text('SENDING');

	succ_int = setInterval(() => {

		let succ_msg = $('#share-form .success').text();

		if(succ_msg=='success') {

			// if single email sent

			if(platform=='sembtn') {

				console.log('Message sent !');
				clearInterval(succ_int);
				// reset success message
				$('#share-form .success').text('');
				$(tgtbtn).find('.share-new-btn-text').text('SENT');
				$(tgtbtn).find('.share-new-btn-icon').addClass('sent');

				setTimeout(()=> {
					$('#overview').css({
						'opacity':1,
						'pointer-events': 'all'
					})
					$(tgtbtn).find('.share-new-btn-text').text('SEND NOW');
					$(tgtbtn).find('.share-new-btn-icon').removeClass('sent');
				}, 2000);

			} else {
				// if team email sent
				
				if(team_count==team_mails.length-1) {
					clearInterval(succ_int);
					// reset success message
					$('#share-form .success').text('');
					$(tgtbtn).find('.share-new-btn-text').text('SENT');
					$(tgtbtn).find('.share-new-btn-icon').addClass('sent');

					setTimeout(()=> {
						$('#overview').css({
							'opacity':1,
							'pointer-events': 'all'
						})
						$(tgtbtn).find('.share-new-btn-text').text('SEND NOW');
						$(tgtbtn).find('.share-new-btn-icon').removeClass('sent');
					}, 2000);
				} else {
					team_count++;
					$('#share-form .success').text('');
					$('#share-form #replyemail').val(team_mails[team_count]);
					setTimeout(()=> {
							$('#share-sub').trigger('click');
					}, 200)
				}				
			}
		}
	}, 30);

	setTimeout(()=> {
			$('#share-sub').trigger('click');
	}, 200)
}


function shareDesignOld(){
	var imgtitle = "Check Out My Turn Uniform"
	var file_path = window.location.href.split('#')[0]+'/img/logo.png'
	var platform = $(this).attr('id')
	var share_url = getDesignUrl()
	switch(platform){
		
		 case 'qu':
		  	gotoTab(4)
		 break;
		 
		case 'fb':
			window.open("https://www.facebook.com/sharer/sharer.php?p[url]="+escape(share_url)+"&p[title]="+imgtitle + "&p[images][0]=" + file_path, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
		 break;
		 
		case 'tw':
			window.open('http://twitter.com/share?text='+imgtitle+'&url='+escape(share_url));
		 break;
		 
		case 'embtn':
		    $('#status').slideDown(300)
			$('#status').text('sending email...');
			var qdata = {
			emails: $('#team-text').val(),
			url: share_url
		};
			$.ajax({
				type: "POST",
				url: phpurl+"php/send_mates.php",
				data: qdata,
				success: function(){
				$('#status').text('email sent !')
				setTimeout(function(){$('#status').slideUp(300)},2000)
				
				}
			});
		break;
	}
}

function getDesignUrl(){
	 
	var share_url = "https://www.turn-gymnastics.com/pages/custom-kit-builder-singlet/?design="
	share_url += currdesign+'/'+currcolors.join('-')+'/'+currlogos.join('-')+'/'+teamname+'/'+currpattern+'/'+currpatype+'/'+currside.join('-') +'/'+font_id +'/'+escape(team_name)+'/'+ctr_vals[0].join('_') + '_' + ctr_vals[1].join('_') + '/' + curr_bind;
	return share_url
}

function setPatternSide(pid){
	if ($('.sidechoose:eq('+(pid-2)+')').hasClass('pattern-selected'))
	{
		
		$('.sidechoose:eq('+(pid-2)+')').removeClass('pattern-selected')
		currside[pid-2] = 0
	}
	else
	{
		currside[pid-2] = 1
		$('.sidechoose:eq('+(pid-2)+')').addClass('pattern-selected')
	}
	
	if(currpattern !=-1){
		setPattern(currpattern)
	}
}

function setPatternType(pid){

	currpatype = pid

	$('.patternchoose').removeClass('pattern-selected')
	$('.patternchoose:eq('+pid+')').addClass('pattern-selected')
	
	if(currpattern !=-1){
		setPattern(currpattern)
	}

}

function setPattern(pid){
	//$('.pattern-fill').attr('fill','url()')
	
	currpattern = pid
	curpatimg = patterns[currpattern]
	$('.pat-thumb-title').removeClass('pat-thumb-title-selected')
	$('.pat-thumb-title:eq('+pid+')').addClass('pat-thumb-title-selected')
	if(currpatype != -1){
		
		$('#patdefs').empty()
		
		//$('.pattern-fill').attr('fill','url()')
        $('.pattern-fill').attr('fill','rgba(0,0,0,0)');
		createPattern('','pat-loaded')
		createPattern('-back','pat-loaded-back')
		
		$(currside).each(function(index, element) {
			if(element==1 && index==0){
				$('.front').attr('fill','url(#pat-loaded)')
			}
			if(element==1 && index==1){
				$('.back').attr('fill','url(#pat-loaded-back)')
			}
        });	
	}
}

function createPattern(pside,pid){
	var patsample = document.createElementNS('http://www.w3.org/2000/svg','pattern');
	patsample.setAttribute('id',pid)
	patsample.setAttribute('patternUnits','userSpaceOnUse')
	patsample.setAttribute('x',100)
	patsample.setAttribute('y',50)
	patsample.setAttribute('width',297)
	patsample.setAttribute('height',550)
	
	var patloaded = document.createElementNS('http://www.w3.org/2000/svg','image');
	var shade = currpatype==0?'light':'dark'
	patloaded.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href',pattern_url+curpatimg+'-'+shade+pside+'.png?'+new Date().getTime())
	patloaded.setAttribute('x',0)
	patloaded.setAttribute('y',0)
	patloaded.setAttribute('width',297)
	patloaded.setAttribute('height',550)
	$(patloaded).appendTo($(patsample))
	$(patsample).appendTo($('#patdefs'))
}

// gradient picker

var isgradient=false;
var grad_a = '#444444';
var grad_b = '#d6d6d6';
var grad_a_pct = 0;
var grad_b_pct = 1;
var grad_color = ['#444444',0,100];
var first_update = 0;
let grad_slider

function initGradientPicker(){
	
	
	$('#grad-check').bind('click',onGradCheck)
	
	$('#grad-color').bind('click',function(){
		$('.grad-color').removeClass('grad-focus');
		setNewGradColor();
	})
	
	var range = document.getElementById('grad-pct');
	
	var top_val = 0
	var bot_val = 1
	
	if(currcolors[6].indexOf('.')!=-1){
		 
		var colsplit = currcolors[6].split('.');
	    grad_color[0] = '#'+colsplit[0];
		grad_color[1] = colsplit[1];
		grad_color[2] = colsplit[2];
		first_update = 3;
		top_val = grad_color[1]/100;
		bot_val = grad_color[2]/100;
	
	}
	  
	
	grad_slider = noUiSlider.create(range, {
		start: [ top_val, bot_val ], // 4 handles, starting at...
		margin: 0, // Handles must be at least 300 apart
		connect: true, // Display a colored bar between the handles
		direction: 'ltr', // Put '0' at the bottom of the slider
		orientation: 'vertical', // Orient the slider vertically
		behaviour: 'tap-drag', // Move handle on tap, bar is draggable
		step: 0.01,
		tooltips: false,
		range: {
			'min': 0,
			'max': 1
		}
	});
	
	if(currcolors[6].indexOf('.')!=-1){
		isgradient=true
		$('#grad-check').addClass('grad-check-selected')
		$('#grad-bot').addClass('grad-focus')
	}
	else
	{
		isgradient=false
		$('.grad-color').removeClass('grad-focus')
	}
	
	range.noUiSlider.on('update', function( values, handle ) {
		
		grad_a_pct = values[0]
		grad_color[1] = Math.floor(grad_a_pct*100)
		grad_b_pct = values[1]
		grad_color[2] = Math.floor(grad_b_pct*100)
		
		$('.grad-color').removeClass('grad-focus');
		setNewGradColor();
		
		$('#colsamp').css('background-color',grad_color[0])
		$('#color').val(grad_color[0])
		
		if(isgradient==true){
			//picker.setColor(grad_color[samp_id]);
		}
			
	})
	
	$('#colsamp').css('background-color','#'+currcolors[0]);
	$('#color').val('#'+currcolors[0]);
	
	if(isgradient==false){
		$('.grad-color').removeClass('grad-focus')
	}
	
}

function onGradCheck(){
		
	$('.grad-color').removeClass('grad-focus');
	
	if(isgradient==false){
		isgradient=true;
		$(this).addClass('grad-check-selected');
		setNewGradColor();
	}else{
		isgradient=false;
		$(this).removeClass('grad-check-selected');
		$('.new-grad').attr('fill','transparent');
		currcolors[6]  = currcolors[6].split('.')[0];
	}
}


function onGradPicker(){
	grad_color[0] = grad_a = picker.color;
	$('#colsamp').css('background-color',picker.color)
	setNewGradColor();
}


function setGradColor(){

	
	updateGradSample();
	setNewGradColor();

	first_update ++
    if(first_update>2){

		isgradient=true
		$('#grad-check').addClass('grad-check-selected')
		$('#grad-check').attr("checked", "checked")

		$('#body-gradient stop:eq(0)').attr('stop-color',grad_color[0])
		$('#body-gradient stop:eq(1)').attr('stop-color',grad_color[0])

		$('#body-gradient').attr('y1',grad_color[1]/100)
		$('#body-gradient').attr('y2',grad_color[2]/100)
		
		$('.new-grad').attr('fill','url(#body-gradient)')
		$('.new-grad').find('path,rect,polygon,polyline').not('[class*="pattern-fill"]').attr('fill','url(#body-gradient)')
	
		currcolors[6] = grad_color.join('.').split('#').join('')
		first_update = 2
	}

	currcolors[6] = grad_color.join('.').split('#').join('');
}

function setBinding(_bind) {
  
  $('.b-select').removeClass('selected').eq(_bind).addClass('selected');
  
  $('.bb, .bbg').hide();

  
  if(_bind==0) {
    $('.b-n,.bbg.b-r').show();
    $('.bb, .col4').attr('fill', 'none');
  }
  
  if(_bind==1) {
    $('.b-r').show();
	$('.bb, .col4, .col4 path').attr('fill', '#' + currcolors[3]);
  }
  
  if(_bind==2) {
    $('.b-v').show();
	$('.bb, .col4, .col4 path').attr('fill', '#' + currcolors[3]);
  }

  if(_bind==3) {
    $('.b-e').show();
	$('.bb, .col4, .col4 path').attr('fill', '#' + currcolors[3]);
  }
  
  curr_bind = _bind;
  calculatePrice();
}



// new gradient style /////////////////////////////////

function initNewGradientStyle() {

	// remove old grad samples
	$('#grad-top').remove();
	$('#grad-bot').remove();
	$('#grad-color').css( {
		'margin-top': '5px',
		'height': '140px'
	})
	$('#grad-pct').css({
		'height': '117px'
	})

	let flipper = $('<label>FLIP<input id="grad-flip" type="checkbox" style="position: relative; top: 1px; opacity:0"></label>"');
	flipper.insertAfter('#grad-pct');
	flipper.css({
		'position': 'absolute',
		'right': '-1px',
		'bottom': '-15px',
		'font-size': '16px',
		'cursor': 'pointer'
	})

	$('#grad-flip').on('change', flipGradient);

	// add new gradient container
	$('#design .pattern-fill.back').each(function(index, element) {
		let grad = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
		grad.setAttribute('x', 97);
		grad.setAttribute('y', 64.89);
		grad.setAttribute('width', 593);
		grad.setAttribute('height', 524.62);
		grad.classList.add('new-grad');
		grad.setAttribute('fill', 'transparent');
		$(grad).insertAfter(element);
	})
}

function hexToRgbA(hex,a){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+a+')';
    }
    throw new Error('Bad Hex');
}

function updateGradSample() {

	let colrgba = hexToRgbA(grad_color[0],0);

	$('#grad-color').css(
		{
			'background': '-webkit-linear-gradient(top,  '+grad_color[0]+' '+grad_color[1]+'%,'+colrgba+' '+grad_color[2]+'%)',
			'background': '-o-linear-gradient(top,  '+grad_color[0]+' '+grad_color[1]+'%,'+colrgba+' '+grad_color[2]+'%)',
			'background': '-moz-linear-gradient(top,  '+grad_color[0]+' '+grad_color[1]+'%,'+colrgba+' '+grad_color[2]+'%)',
			'background': 'linear-gradient(to bottom, '+grad_color[0]+' '+grad_color[1]+'%,'+colrgba+' '+grad_color[2]+'%)'
		}
	)
}

function setNewGradColor() {

	first_update ++
    if(first_update>2){

		let colrgba = hexToRgbA(grad_color[0],0);

		isgradient=true
		$('#grad-check').addClass('grad-check-selected');
		$('#grad-check').attr("checked", "checked");

		if(grad_flip==true) {
			$('#body-gradient stop:eq(0)').attr('stop-color',colrgba);
			$('#body-gradient stop:eq(1)').attr('stop-color',grad_color[0]);
		} else {
			$('#body-gradient stop:eq(0)').attr('stop-color',grad_color[0]);
			$('#body-gradient stop:eq(1)').attr('stop-color',colrgba);
		}


		$('#body-gradient').attr('y1',grad_color[1]/100);
		$('#body-gradient').attr('y2',grad_color[2]/100);

		$('.new-grad').attr('fill','url(#body-gradient)');

		currcolors[6] = grad_color.join('.').split('#').join('');
		first_update = 2;
	}

	currcolors[6] = grad_color.join('.').split('#').join('');
}

let grad_flip = false;

function flipGradient() {

	grad_flip = $('#grad-flip').prop('checked');

	grad_tmp = 100-grad_color[2];
	grad_color[2] = 100-grad_color[1];
	grad_color[1] = grad_tmp;
	grad_slider.set([grad_color[1]/100,grad_color[2]/100]);

	setNewGradColor();
}